import { ProfileType } from '@witkac/kartamiejska-shared';
import defaultSchema from './default.schema';

export default {
  ...defaultSchema,
  title: 'user',
  type: 'object',
  properties: {
    profile: {
      type: 'object',
      title: 'Profil',
      properties: {
        type: {
          type: 'string',
          fieldRequired: true,
          default: ProfileType.CLIENT
        },
        firstName: {
          title: 'Imię',
          type: 'string',
          fieldRequired: true
        },
        lastName: {
          title: 'Nazwisko',
          type: 'string',
          fieldRequired: true
        },
        birthDate: {
          prependIcon: 'mdi-calendar',
          title: 'Data urodzenia',
          type: 'string',
          format: 'date',
          fieldRequired: true,
          validationMessages: {
            format: 'Nieprawidłowy format. Przykład: 01.01.1990'
          }
        },
        email: {
          title: 'Adres e-mail *',
          type: 'string',
          computed: true,
          calc: '$root.login'
        },
        phoneNumber: {
          title: 'Numer telefonu (opcjonalne)',
          type: 'string',
          fieldRequired: false
        },
        gender: {
          title: 'Płeć',
          type: 'number',
          fieldRequired: true
        },
        woj: {
          title: 'Województwo',
          type: 'string',
          fieldRequired: true
        },
        pow: {
          title: 'Powiat',
          type: 'string',
          fieldRequired: true
        },
        gmi: {
          title: 'Gmina',
          type: 'string',
          fieldRequired: true
        },
        terc: {
          title: 'Kod TERC',
          type: 'string',
          fieldRequired: true,
          minLength: 6
        },
        city: {
          title: 'Miejscowość',
          type: 'string',
          fieldRequired: true
        },
        simc: {
          title: 'Kod SIMC',
          type: 'string',
          fieldRequired: true
        },
        street: {
          title: 'Ulica *',
          type: 'string',
          fieldRequired: true
        },
        ulic: {
          title: 'Kod ULIC',
          type: 'string',
          fieldRequired: false
        },
        postalCode: {
          title: 'Kod pocztowy',
          type: 'string',
          format: 'kod',
          fieldRequired: true,
          validationMessages: {
            format: 'Niepoprawny kod pocztowy'
          }
        },
        homeNumber: {
          title: 'Numer budynku*',
          type: 'string',
          fieldRequired: true
        },
        localNumber: {
          title: 'Numer lokalu',
          type: 'string',
          fieldRequired: false
        },
        mainImage: {
          type: 'number'
        }
      }
    }
  }
};
